import request from "../utils/request";

// agentBillRecharge/recharge
export const agentBillRecharge = (data) => {
  return request({
    url: '/agentBillRecharge/recharge',
    method: 'get',
    params: data,
    responseType: 'blob'
  })
}

// agentBillRecharge/rechargeList
export const agentBillRechargeList = (data) => {
  return request({
    url: '/agentBillRecharge/rechargeList',
    method: 'post',
    data: data,
  })
}

//agentBillRecharge/gbpay/queryPaymentResult
export const queryPaymentResult = () => {
  return request({
    url: '/agentBillRecharge/gbpay/queryPaymentResult',
    method: 'get',
  })
}

// agentBillRecharge/ams/billflow
export const billflow = (data) => {
  return request({
    url: '/agentBillRecharge/ams/billflow',
    method: 'get',
    params: data,
  })
}

// agentBillPkg/getPageByBillId
export const getPageByBillId = (data) => {
  return request({
    url: '/agentBillPkg/getPageByBillId',
    method: 'get',
    params: data,
  })
}
